const IOS_DEVICES = ['iPhone Simulator', 'iPod Simulator', 'iPhone', 'iPod']

export const isiOSDevice = (): boolean => {
  return IOS_DEVICES.some((deviceName: string) => navigator.userAgent.includes(deviceName));
};
